export default __webpack_public_path__ + "static/media/IlustraçãoHome.fa4e1df9.svg";